import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AiEventType } from "../../../types/ai-event";
import type { QueuedAiMessage } from "../../../slices/ui";
import { TextBlock } from "./TextBlock";

interface QueuedMessageProps {
  message: QueuedAiMessage;
  onCancel: (id: string) => void;
}

// A message sent while Cas is working: the same wrapping user bubble as a sent one, with a small
// "Queued" caption under it and a cancel control beside it. It is drawn from state.ui.aiQueued, not
// from the transcript, and becomes a normal user message only when the composer sends it.
export const QueuedMessage: React.FC<QueuedMessageProps> = ({ message, onCancel }) => (
  <Box data-testid="queued-message" sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", minWidth: 0 }}>
    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "flex-start", gap: 0.5, width: "100%", minWidth: 0 }}>
      <IconButton data-testid="queued-cancel" aria-label="Remove queued message" size="small" onClick={() => onCancel(message.id)}>
        <CloseIcon fontSize="inherit" />
      </IconButton>
      <TextBlock testId="msg-queued" event={{ type: AiEventType.USER_MESSAGE, content: message.content, timestamp: 0 }} />
    </Box>
    <Typography data-testid="queued-caption" variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem", pr: 0.5 }}>
      Queued
    </Typography>
  </Box>
);
